import { render, staticRenderFns } from "./TabListTwoCol.vue?vue&type=template&id=bac490bc&scoped=true&"
import script from "./TabListTwoCol.vue?vue&type=script&lang=js&"
export * from "./TabListTwoCol.vue?vue&type=script&lang=js&"
import style0 from "./TabListTwoCol.vue?vue&type=style&index=0&id=bac490bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac490bc",
  null
  
)

export default component.exports